import { __ } from '@wordpress/i18n';
import {
	Calendar,
	CheckSquare,
	Heading1,
	Heading2,
	Heading3,
	Image,
	List,
	ListOrdered,
	Minus,
	Text,
	TextAlignStart,
	TextQuote,
	Video,
	VolumeIcon,
} from 'lucide-react';
import { Command, createSuggestionItems, renderItems } from './core';

export const suggestionItems = createSuggestionItems([
	{
		group: __('Content', 'allcoach'),
		title: __('Text', 'allcoach'),
		description: __('Plain text paragraph.', 'allcoach'),
		searchTerms: ['p', 'paragraph'],
		icon: <Text size={13} />,
		command: ({ editor, range }) => {
			editor
				.chain()
				.focus()
				.deleteRange(range)
				.toggleNode('paragraph', 'paragraph')
				.run();
		},
	},
	{
		group: __('Content', 'allcoach'),
		title: __('Heading 1', 'allcoach'),
		description: __('Large section heading.', 'allcoach'),
		searchTerms: ['title', 'big', 'large', 'h1'],
		icon: <Heading1 size={13} />,
		command: ({ editor, range }) => {
			editor
				.chain()
				.focus()
				.deleteRange(range)
				.setNode('heading', { level: 1 })
				.run();
		},
	},
	{
		group: __('Content', 'allcoach'),
		title: __('Heading 2', 'allcoach'),
		description: __('Medium section heading.', 'allcoach'),
		searchTerms: ['subtitle', 'medium', 'h2'],
		icon: <Heading2 size={13} />,
		command: ({ editor, range }) => {
			editor
				.chain()
				.focus()
				.deleteRange(range)
				.setNode('heading', { level: 2 })
				.run();
		},
	},
	{
		group: __('Content', 'allcoach'),
		title: __('Heading 3', 'allcoach'),
		description: __('Small section heading.', 'allcoach'),
		searchTerms: ['subtitle', 'small', 'h3'],
		icon: <Heading3 size={13} />,
		command: ({ editor, range }) => {
			editor
				.chain()
				.focus()
				.deleteRange(range)
				.setNode('heading', { level: 3 })
				.run();
		},
	},
	{
		group: __('Content', 'allcoach'),
		title: __('Bullet List', 'allcoach'),
		description: __('Unordered list.', 'allcoach'),
		searchTerms: ['unordered', 'point', 'ul'],
		icon: <List size={13} />,
		command: ({ editor, range }) => {
			editor.chain().focus().deleteRange(range).toggleBulletList().run();
		},
	},
	{
		group: __('Content', 'allcoach'),
		title: __('Numbered List', 'allcoach'),
		description: __('Ordered list with numbering.', 'allcoach'),
		searchTerms: ['ordered', 'ol'],
		icon: <ListOrdered size={13} />,
		command: ({ editor, range }) => {
			editor.chain().focus().deleteRange(range).toggleOrderedList().run();
		},
	},
	{
		group: __('Content', 'allcoach'),
		title: __('Quote', 'allcoach'),
		description: __('Highlighted quote block.', 'allcoach'),
		searchTerms: ['blockquote'],
		icon: <TextQuote size={13} />,
		command: ({ editor, range }) =>
			editor
				.chain()
				.focus()
				.deleteRange(range)
				.toggleNode('paragraph', 'paragraph')
				.toggleBlockquote()
				.run(),
	},
	{
		group: __('Content', 'allcoach'),
		title: __('Separator', 'allcoach'),
		description: __('Horizontal divider line.', 'allcoach'),
		searchTerms: ['separator', 'divider', 'hr', 'rule'],
		icon: <Minus size={13} />,
		command: ({ editor, range }) =>
			editor.chain().focus().deleteRange(range).setHorizontalRule().run(),
	},

	{
		group: __('Input Elements', 'allcoach'),
		title: __('Short Answer', 'allcoach'),
		description: __('Single line text field.', 'allcoach'),
		searchTerms: ['short', 'answer', 'input', 'question'],
		icon: <Minus size={13} />,
		command: ({ editor, range }) =>
			editor.chain().focus().deleteRange(range).insertShortAnswer().run(),
	},
	{
		group: __('Input Elements', 'allcoach'),
		title: __('Long Answer', 'allcoach'),
		description: __('Multi-line text area.', 'allcoach'),
		searchTerms: ['long', 'answer', 'textarea', 'question'],
		icon: <TextAlignStart size={13} />,
		command: ({ editor, range }) =>
			editor.chain().focus().deleteRange(range).insertLongAnswer().run(),
	},
	{
		group: __('Input Elements', 'allcoach'),
		title: __('Single Choice', 'allcoach'),
		description: __('Single select with options.', 'allcoach'),
		searchTerms: ['radio', 'choice', 'select', 'multiple'],
		icon: <List size={13} />,
		command: ({ editor, range }) =>
			editor.chain().focus().deleteRange(range).insertMultipleChoice().run(),
	},
	{
		group: __('Input Elements', 'allcoach'),
		title: __('Checkboxes', 'allcoach'),
		description: __('Multi-select with options.', 'allcoach'),
		searchTerms: ['checkbox', 'multi', 'check'],
		icon: <CheckSquare size={13} />,
		command: ({ editor, range }) =>
			editor.chain().focus().deleteRange(range).insertCheckbox().run(),
	},
	{
		group: __('Input Elements', 'allcoach'),
		title: __('Date', 'allcoach'),
		description: __('Date picker field.', 'allcoach'),
		searchTerms: ['date', 'calendar', 'picker'],
		icon: <Calendar size={13} />,
		command: ({ editor, range }) =>
			editor.chain().focus().deleteRange(range).insertDate().run(),
	},

	{
		group: __('Media Elements', 'allcoach'),
		title: __('Image', 'allcoach'),
		description: __('Upload or embed an image.', 'allcoach'),
		searchTerms: ['image', 'photo', 'picture', 'media'],
		icon: <Image size={13} />,
		command: ({ editor, range }) =>
			editor.chain().focus().deleteRange(range).insertImage().run(),
	},
	{
		group: __('Media Elements', 'allcoach'),
		title: __('Audio', 'allcoach'),
		description: __('Embed an audio file.', 'allcoach'),
		searchTerms: ['audio', 'media', 'mp3', 'sound'],
		icon: <VolumeIcon size={13} />,
		command: ({ editor, range }) =>
			editor.chain().focus().deleteRange(range).insertAudio().run(),
	},
	{
		group: __('Media Elements', 'allcoach'),
		title: __('Video', 'allcoach'),
		description: __('Embed a video.', 'allcoach'),
		searchTerms: ['video', 'media', 'mp4'],
		icon: <Video size={13} />,
		command: ({ editor, range }) =>
			editor.chain().focus().deleteRange(range).insertVideo().run(),
	},
]);

export const slashCommand = Command.configure({
	// @ts-ignore
	suggestion: {
		items: ({ query }) => {
			return suggestionItems.filter(
				(item) =>
					item.title.toLowerCase().includes(query.toLowerCase()) ||
					item.searchTerms?.some((term) => term.includes(query.toLowerCase())),
			);
		},
		render: renderItems,
	},
});
